import merge from 'lodash.merge';
import { completeDataStreams } from '../completeDataStreams';
export class CreateTimeSeriesDataStore {
    constructor({ initialState, callback, }) {
        this.callback = callback;
        this.state = { ...initialState };
    }
    update() {
        const { thresholds, viewport, alarms, assetModels, dataStreams, modeledDataStreams, } = this.state; //add assetProeprties
        this.callback({
            dataStreams: completeDataStreams({
                dataStreams,
                assetModels,
                alarms,
                modeledDataStreams,
            }),
            viewport,
            thresholds,
        });
    }
    appendTimeSeriesData(updatedState) {
        const { thresholds, dataStreams, modeledDataStreams, ...rest } = updatedState;
        const newDataStreams = dataStreams === null || dataStreams === void 0 ? void 0 : dataStreams.filter((dataStream) => !this.state.dataStreams.map(({ id }) => id).includes(dataStream.id));
        this.state.dataStreams = [
            ...this.state.dataStreams.map((dataStream) => {
                const updatedDataStream = dataStreams === null || dataStreams === void 0 ? void 0 : dataStreams.find(({ id }) => dataStream.id === id);
                if (updatedDataStream) {
                    return { ...dataStream, ...updatedDataStream };
                }
                return dataStream;
            }),
            ...(newDataStreams || []),
        ];
        this.state.modeledDataStreams = [
            ...this.state.modeledDataStreams,
            ...(modeledDataStreams || []),
        ];
        this.state.thresholds = [...this.state.thresholds, ...(thresholds || [])];
        merge(this.state, rest);
        this.update();
    }
    getState() {
        return this.state;
    }
}
